<template src="./MenuSelect.html"> </template>

<script>
import { mapActions } from "vuex";

export default {
    name: 'MenuSelect',
    props: {
      items: {
        required: true,
        type: Array,
      },
      label: {
        required: true,
        type: String
      },
      itemSelected: {
        type: String,
        required: false,
      }
    },
    data() {
      return {
        selected: this.itemSelected,
      }
    },
    methods: {

      ...mapActions({
        setMenuLocale: "setMenuLocale",
        setMenuPeriod: "setMenuPeriod",
      }),

      onSelect() {
        this.$emit('input', this.selected);   
      }
      
    }
}
</script>

<style lang="scss" src="./MenuSelect.scss"> </style>